import { queryOptions } from '@tanstack/react-query';
import type { Meeting } from '@meeting-assistant/schemas';
import { getMeeting } from '@/lib/api';

export const meetingQueryOptions = (meetingId: string) =>
  queryOptions<Meeting>({
    queryKey: ['meeting', meetingId],
    queryFn: () => getMeeting(meetingId),
  });
